import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DragulaModule } from 'ng2-dragula';
import { TranslateModule } from '@ngx-translate/core';
// Components
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CustomizerComponent } from './components/customizer/customizer.component';
import { FeatherIconsComponent } from './components/feather-icons/feather-icons.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { ContentComponent } from './components/layout/content/content.component';
import { FullComponent } from './components/layout/full/full.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TapToTopComponent } from './components/tap-to-top/tap-to-top.component';
// Header Elements Components
import { SearchComponent } from './components/header/elements/search/search.component';
import { MegaMenuComponent } from './components/header/elements/mega-menu/mega-menu.component';
import { LanguagesComponent } from './components/header/elements/languages/languages.component';
import { NotificationComponent } from './components/header/elements/notification/notification.component';
import { BookmarkComponent } from './components/header/elements/bookmark/bookmark.component';
import { CartComponent } from './components/header/elements/cart/cart.component';
import { MessageBoxComponent } from './components/header/elements/message-box/message-box.component';
import { MyAccountComponent } from './components/header/elements/my-account/my-account.component';
// Directives
import { DisableKeyPressDirective } from './directives/disable-key-press.directive';
import { OnlyAlphabetsDirective } from './directives/only-alphabets.directive';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { ShowOptionsDirective } from './directives/show-options.directive';
// Services
import { ChatService } from './services/chat.service';
import { LayoutService } from './services/layout.service';
import { NavService } from './services/nav.service';
import { TagModalComponent } from './components/modal/tag-modal/tag-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClientModule } from '@angular/common/http';
import { TagInputModule } from 'ngx-chips';
import { ModifierRuleComponent } from './components/modal/modifier-rule/modifier-rule.component';
import { ConfirmModalComponent } from './components/modal/confirm-modal/confirm-modal.component';
import { VideoModalComponent } from './components/modal/video-modal/video-modal.component';
import { Ng5SliderModule } from 'ng5-slider';
import { Ng2DropdownModule } from 'ng2-material-dropdown';
import { ShareTopicComponent } from './components/modal/share-topic/share-topic.component';
import { UserModalComponent } from './components/modal/user-modal/user-modal.component';
import { FilesViewModalComponent } from './components/modal/files-view-modal/files-view-modal.component';
import { MediaUploadModalComponent } from './components/modal/media-upload-modal/media-upload-modal.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { PackagePaymentModalComponent } from './components/modal/package-payment-modal/package-payment-modal.component';
import { PlaybookAddModalComponent } from './components/modal/playbook-add-modal/playbook-add-modal.component';
import { UpdateModalComponent } from './components/modal/offense-update-required-modal/offense-update-required-modal';
import { PhoneMaskDirective } from '../phone-mask.directive';
import { ThreeJsComponent } from './components/modal/three-js/three-js.component';
import { PreviewComponent } from './components/modal/preview/preview.component';
import { OpppsiteThreeJsComponent } from './components/modal/opppsite-three-js/opppsite-three-js.component';
import { BaseThreeJsComponent } from './components/modal/base-three-js/base-three-js.component';
import { HowWorksComponent } from './components/modal/how-works/how-works.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ContentComponent,
    BreadcrumbComponent,
    CustomizerComponent,
    FeatherIconsComponent,
    FullComponent,
    ShowOptionsDirective,
    DisableKeyPressDirective,
    OnlyAlphabetsDirective,
    OnlyNumbersDirective,
    LoaderComponent,
    TapToTopComponent,
    SearchComponent,
    MegaMenuComponent,
    LanguagesComponent,
    NotificationComponent,
    BookmarkComponent,
    CartComponent,
    MessageBoxComponent,
    MyAccountComponent,
    TagModalComponent,
    ModifierRuleComponent,
    ConfirmModalComponent,
    VideoModalComponent,
    ShareTopicComponent,
    UserModalComponent,
    FilesViewModalComponent,
    MediaUploadModalComponent,
    PackagePaymentModalComponent,
    PlaybookAddModalComponent,
    UpdateModalComponent,
    BaseThreeJsComponent,
    ThreeJsComponent,
    OpppsiteThreeJsComponent,
    PreviewComponent,
    PhoneMaskDirective,
    HowWorksComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    DragulaModule.forRoot(),
    TranslateModule,
    HttpClientModule,
    NgSelectModule,
    TagInputModule,
    Ng5SliderModule,
    Ng2DropdownModule,
    NgxDropzoneModule,
  ],
  providers: [
    NavService,
    ChatService,
    LayoutService
  ],
  exports: [
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    LoaderComponent,
    BreadcrumbComponent,
    FeatherIconsComponent,
    TapToTopComponent,
    DisableKeyPressDirective,
    OnlyAlphabetsDirective,
    OnlyNumbersDirective,
    BaseThreeJsComponent,
    ThreeJsComponent,
    OpppsiteThreeJsComponent,
    PhoneMaskDirective,
    HowWorksComponent
  ],
})
export class SharedModule { }
